import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoginRequired from '../auth/LoginRequired';
import LoadingScreen from '../common/LoadingScreen';

/**
 * ProtectedRoute - Wrapper component that shows LoginRequired for unauthenticated users
 * and renders children for authenticated users
 */
const ProtectedRoute = ({ children, requiresAuth = true }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  // Show loading while Auth0 is checking authentication status
  if (isLoading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  // If route requires auth and user is not authenticated, show login page
  if (requiresAuth && !isAuthenticated) {
    return <LoginRequired />;
  }

  // User is authenticated or route doesn't require auth - render children
  return children;
};

export default ProtectedRoute;
